<template>
    <div class="artist">
        <div class="row">

            <ArtistProfileMedia/>

            <div class="col-lg-7" v-if="artistShowInfo">
                <div class="artist__content">
                    <div class="artist__top mb-5">
                        <p
                            class="color_primary"
                            v-for="category in artistCategories"
                            :key="category.id"
                        >
                            {{category.name}}
                        </p>
                        <div class="artist__booking">
                            <a href="" class="action"><i class="fa-solid fa-file-pdf"></i></a>
                            <a href="" class="action"><i class="fa-solid fa-print"></i></a>
                            <a :href="`/client/artist/${artistId}/book`" class="btn btn_golden"><span>book now</span></a>
                        </div>
                    </div>
                    <h2 class="artist__ttl"> {{ artistShowInfo.title}}</h2>
                    <p>{{ artistShowInfo.description}}</p>
                    <div
                        v-for="show in artistShowInfo.shows"
                        :key="show.index"
                    >
                        <h2 class="artist__ttl">{{show.show_title}}</h2>
                        <h3 class="artist__sub-ttl">Show duration: {{show.show_duration}}</h3>
                        <div class="artist__info">
                            {{show.show_description}}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArtistProfileMedia from "../Common/ArtistProfileMedia.vue";
import {mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";

export default {
    name: 'ArtistShowsInformation',
    components: {ArtistProfileMedia},
    computed: {
        ...mapState(useClientStore, {
            artistId: 'artistId',
            artistShowInfo: 'artistShowInfo',
            artistCategories: 'artistCategories',
        })
    }

}

</script>



<style scoped>

</style>
